import { useTranslation } from "react-i18next";
import "./Process.css";

const STEPS = ["01", "02", "03", "04"];

export default function Process() {
  const { t } = useTranslation();
  return (
    <section id="processo" className="process section section--dark">
      <div className="container">
        <header className="process__header">
          <span className="process__eyebrow">{t("process.eyebrow")}</span>
          <h2 className="process__title">{t("process.title")}</h2>
          <p className="process__lead">{t("process.lead")}</p>
        </header>

        <ol className="process__list">
          {STEPS.map((num) => (
            <li key={num} className="process__item">
              <span className="process__num">{num}</span>
              <div className="process__content">
                <h3 className="process__step-title">{t(`process.steps.${num}.title`)}</h3>
                <p className="process__step-body">{t(`process.steps.${num}.body`)}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
